// extracted by mini-css-extract-plugin
export default {"infoContainer":"CensusAverageBox_infoContainer__LAl-0","infoWrapper":"CensusAverageBox_infoWrapper__T1bd4","skeleton":"CensusAverageBox_skeleton__xap0S"};